import { render, staticRenderFns } from "./crm-tag-meta-data.vue?vue&type=template&id=e1a91cac&scoped=true&"
import script from "./crm-tag-meta-data.vue?vue&type=script&lang=js&"
export * from "./crm-tag-meta-data.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e1a91cac",
  null
  
)

export default component.exports